import { DropdownItem } from "../pages/createSegment/segment-interface";

// Helper function to clean and normalize labels for consistent comparison
// Removes surrounding quotes
// Trims whitespace
// Converts to lowercase for case-insensitive matching

const normalizeLabel = (label: string) =>
  label
    .replace(/^"+|"+$/g, "")
    .replace(/^'+|'+$/g, "")
    .trim()
    .toLowerCase();

// Recursively finds and returns a dropdown field node based on a given path (array of labels)

export const findFieldByPath = (items: DropdownItem[], path: string[]): DropdownItem | null => {
  let current: DropdownItem[] = items;
  let node: DropdownItem | null = null;

  for (const segment of path) {
    node = current.find((i) => normalizeLabel(i.label) === normalizeLabel(segment)) || null;

    if (!node) {
      console.warn(`Could not find a match for "${segment}"`);
      return null;
    }

    current = node.children ?? [];
  }

  return node;
};
